import { NgModule } from '@angular/core';
import { AbstractDateInputConfig, AbstractFormConfig, AbstractOptionsConfig, EpsAlertModule, EpsButtonModule, EpsCheckboxModule, EpsDateInputModule, EpsDialogModule, EpsFilterListModule, EpsIconModule, EpsLabelBodyModule, EpsLabelModule, EpsNumberInputModule, EpsRadioGroupModule, EpsSelectModule, EpsSpinnerModule, EpsTableModule, EpsTextInputModule, EpsWeekInputModule, } from '@dlw-int-mwi/eps-common';


const abstractFormConfig: AbstractFormConfig = {
  showErrors: true,
}

const abstractDateInputConfig: AbstractDateInputConfig = {
  ...abstractFormConfig,
  outputFormat: 'yyyy-LL-dd',
}

const abstractOptionsConfig: AbstractOptionsConfig = {
  ...abstractFormConfig,
  labelProperty: 'name',
  idProperty: 'id',
}

const modules = [
  EpsLabelModule,
  EpsLabelBodyModule,
  EpsTextInputModule,
  EpsIconModule,
  EpsSpinnerModule,
  EpsButtonModule,
  EpsFilterListModule,
  EpsTableModule,
  EpsDialogModule,
  EpsAlertModule,
];


@NgModule({
  imports: [
    EpsDateInputModule.forRoot(abstractDateInputConfig),
    EpsWeekInputModule.forRoot(abstractDateInputConfig),
    EpsSelectModule.forRoot({
      ...abstractOptionsConfig,
      multiple: false,
      labelsDisplayed: 3,
    }),
    EpsCheckboxModule.forRoot({
      ...abstractOptionsConfig,
      allowIndeterminate: false,
      useIconsInReadonly: true,
    }),
    EpsRadioGroupModule.forRoot({
      ...abstractOptionsConfig,
    }),
    EpsNumberInputModule.forRoot({
      ...abstractFormConfig,
    }),
    ...modules,
  ],
  exports: [
    EpsDateInputModule,
    EpsWeekInputModule,
    EpsSelectModule,
    EpsCheckboxModule,
    EpsNumberInputModule,
    EpsRadioGroupModule,
    ...modules,
  ],
  declarations: [],
})
export class EpsCommonModule {
}
